const MAIN_MENU_TRANSLATION_KEY = 'main-menu';
const MAIN_MENU_AMPLITUDE_SOURCE_DETAIL_KEY = 'Main Menu';
const SEARCH_DIALOG_AMPLITUDE_SOURCE_DETAIL_KEY = 'Search Dialog';
const COOKIES_CONSENT_KEY = 'SHOW_COOKIES_NOTIFICATION';
const NOTIFICATION_AUDIO_URL = 'https://static.crehana.com/static/files/Notification.mp3';
const PHONE_LEAD_CARD_IMG = 'https://crehana-public-catalog.imgix.net/images/app/gallery/2021/10/18/54ae473e/1b43a7fb.png?auto=format';
const USER_MENU_AVATAR_TOUR_ID = 'main-menu-user-menu-avatar';
const DEFAULT_MAIN_MENU_URLS = {
    login: '/entrar/',
    register: '/onboarding/',
    homePage: '/',
    homeUser: '/home/',
    userDashboard: {
        courses: '/panel/mis-cursos/',
        savedCourses: '/panel/mis-cursos-guardados/',
        microDegree: '/panel/mis-cursos/microdegree/',
        projects: '/panel/mis-proyectos/',
        diplomas: '/panel/mis-diplomas/'
    },
    mentorDashboard: '/mentor/panel/proyectos/',
    teacherDashboard: '/panel-profesor/',
    affiliateDashboard: '/afiliados/panel/',
    shoppingCart: '/carrito-de-compras/',
    configuration: '/configuracion/',
    premiumLanding: '/premium/',
    crehanaAcademiesLanding: '/academias/',
    premiumRefer: '/referidos/',
    higherEdLanding: '/business/higher-education/',
    searchLanding: '/cursos-online/search/',
    catalog: '/cursos-online/?all=true',
    newCoursesCatalog: '/cursos-nuevos/',
    blog: '/blog/',
    crehanaLive: '/live/',
    resources: '/recursos/herramientas/',
    courseAgenda: '/agenda-cursos/',
    mentorLanding: '/mentores/',
    inbox: '/inbox/',
    helpCenter: `/help-center/?next_url=${encodeURIComponent('https://ayuda.crehana.com/')}`,
    legal: '/legal/terminos-y-condiciones/',
    appDownload: {
        apple: 'https://itunes.apple.com/us/app/crehana/id1353031284',
        google: 'https://play.google.com/store/apps/details?id=com.crehana.android',
        huawei: 'https://appgallery.cloud.huawei.com/ag/n/app/C101001725'
    },
    createHomeUserB2BUrl: (organizationSlug)=>`/org/${organizationSlug}/learn/`,
    createB2BAdminDashboardUrl: (organizationSlug)=>`/org/${organizationSlug}/panel/`,
    createCatalogKnowledgeHubUrl: (organizationSlug)=>`/org/${organizationSlug}/learn/content/`,
    renewalLanding: '/renovacion/',
    B2BPlansLanding: '/planes',
    downloadableResources: '/business/descargables/'
};
const SEARCH_KEYWORDS_COUNT = 10;
const SEARCH_RESULTS_COUNT = {
    xs: 10,
    sm: 14,
    md: 12,
    lg: 18
};
const SEARCH_DEFAULT_COURSE_SECTION_COUNT = {
    xs: 6,
    sm: 6,
    md: 4,
    lg: 6
};
const SEARCH_CATEGORIES_RECOMMENDED_COUNT = 3;
const SEARCH_BEST_SELLER_COURSES_PHONE_LEAD_CARD_POSITION = 2;
const SEARCH_RESULTS_PHONE_LEAD_CARD_POSITION = 1;
const NEW_COURSES_ORDER_BY = 'nuevos';
const NOTIFICATIONS_COURSES_PER_FETCH = 6;
const NOTIFICATIONS_NEWS_PER_FETCH = 8;
const USER_MENU_RENEWAL_ITEM_SOURCE_DETAIL = 'Main Menu Renewal Card';
const CATALOG_NEW_COURSES_POPPER_COUNT = 3;
export { CATALOG_NEW_COURSES_POPPER_COUNT, COOKIES_CONSENT_KEY, DEFAULT_MAIN_MENU_URLS, MAIN_MENU_AMPLITUDE_SOURCE_DETAIL_KEY, MAIN_MENU_TRANSLATION_KEY, NEW_COURSES_ORDER_BY, NOTIFICATIONS_COURSES_PER_FETCH, NOTIFICATIONS_NEWS_PER_FETCH, NOTIFICATION_AUDIO_URL, PHONE_LEAD_CARD_IMG, SEARCH_BEST_SELLER_COURSES_PHONE_LEAD_CARD_POSITION, SEARCH_CATEGORIES_RECOMMENDED_COUNT, SEARCH_DEFAULT_COURSE_SECTION_COUNT, SEARCH_DIALOG_AMPLITUDE_SOURCE_DETAIL_KEY, SEARCH_KEYWORDS_COUNT, SEARCH_RESULTS_COUNT, SEARCH_RESULTS_PHONE_LEAD_CARD_POSITION, USER_MENU_AVATAR_TOUR_ID, USER_MENU_RENEWAL_ITEM_SOURCE_DETAIL };
